import useSaveNodeInCache from 'components/canvas/hooks/use-save-node-in-cache';
import useFindNodeInCache from 'components/canvas/hooks/use-find-node';
import updateSurfaceNodePosition from 'graphql/surface-node/mutations/update-surface-node-position';
import { toast } from 'services/toast';
import { compose, set } from 'lodash/fp';
import { Position } from 'types';
import { SurfaceNodeType, SurfaceNodeUnion } from 'graphql/types';
import useCanvas from 'components/canvas/hooks/use-canvas';
import useCurrentSurface from 'routes/surface/hooks/use-current-surface';
import { useProtocolNodePositionOperations } from 'components/canvas/components/nodes/components/protocol-node/hooks/use-protocol-operations';

interface UseUpdateNodePosition {
  updateNodePositionInCache(node: SurfaceNodeUnion, position: Position): void;
  updateNodePositionOnServer(
    node: SurfaceNodeUnion,
    position: Position,
  ): Promise<void>;
}

export default function useUpdateNodePosition(
  surfaceId?: string,
): UseUpdateNodePosition {
  const saveNodeInCache = useSaveNodeInCache();

  const {
    updateProtocolNodePositionInCache,
  } = useProtocolNodePositionOperations();

  function updateNodePositionInCache(
    node: SurfaceNodeUnion,
    position: Position,
  ) {
    if (position) {
      const newNode = compose(
        set('position.x', position.x),
        set('position.y', position.y),
      )(node);

      saveNodeInCache(newNode);
    }
  }

  async function updateNodePositionOnServer(
    node: SurfaceNodeUnion,
    position: Position,
  ) {
    const input = {
      nodeId: node.id,
      position,
    };

    updateSurfaceNodePosition({ input }).then((response) => {
    // console.warn("POS RESULT: ", response)

      if (response.isFailure) {
        toast.error(response.getErrorMessage());
      }
    });

    if (position) {
      if (node.type === SurfaceNodeType.Protocol) {
        updateProtocolNodePositionInCache(node, position);

    // console.warn("POS RESULT: ", surfaceNodeShape)

    // console.warn("POS RESULT: ", surfaceNode)
      } else {
        updateNodePositionInCache(node, position);
      }
    }
  }

  return { updateNodePositionInCache, updateNodePositionOnServer };
}
